import {
  listTagLibrary,
  Tag,
  createTagLibrary,
  partialUpdateTagLibrary,
  destroyTagLibrary
} from '@goldcast/api/backend';

const actions = {
  fetchTags({ dispatch, commit, rootGetters }) {
    commit('setIsFetchingTags', true);
    const orgId = rootGetters['org/getCurrentOrgId'];
    return listTagLibrary({
      queryParams: {
        organization: orgId
      }
    })
      .then(data => {
        const tagsLibraryData = data as Tag[];
        const tagsMap = {};
        tagsLibraryData.forEach(tag => {
          tagsMap[tag.id] = tag;
        });
        commit('setTags', tagsMap);
      })
      .catch(error => {
        dispatch(
          'studioToast/triggerToast',
          { msg: 'Error loading Tags library! Please try refreshing the page.', mode: 'error' },
          { root: true }
        );
        commit('setErrorFetchingTags', error);
      })
      .finally(() => {
        commit('setIsFetchingTags', false);
      });
  },
  createNewTag({ dispatch, commit, rootGetters, state }, tagName: string) {
    const orgId: string = rootGetters['org/getCurrentOrgId'];
    const tagToastName = tagName.length > 20 ? `${tagName.slice(0, 20)}...` : tagName;

    return createTagLibrary({
      body: {
        organization: orgId,
        tag_name: tagName
      }
    })
      .then(newTag => {
        commit('setTags', { ...state.tags, [newTag.id]: newTag });
        dispatch('studioToast/triggerToast', { msg: `Tag "${tagToastName}" created`, mode: 'success' }, { root: true });
        return newTag;
      })
      .catch(error => {
        let errorMessage = 'Error creating tag';
        if (error?.apiErrorCode === 'TAG_ALREADY_IN_ENTITY') {
          errorMessage = `Tag with name "${tagToastName}" already exists in the Tag Library`;
        }
        dispatch('studioToast/triggerToast', { msg: errorMessage, mode: 'error' }, { root: true });
        throw error;
      });
  },
  renameTag({ state, dispatch, commit }, { tagId, updatedTagName }: { tagId: string; updatedTagName: string }) {
    return partialUpdateTagLibrary({
      id: tagId,
      body: { tag_name: updatedTagName }
    })
      .then(updatedTag => {
        commit('setTags', { ...state.tags, [tagId]: updatedTag });
      })
      .catch(error => {
        let errorMessage = 'Error creating tag';
        if (error?.apiErrorCode === 'TAG_ALREADY_IN_ENTITY') {
          errorMessage = `Tag with name "${updatedTagName}" already exists in the Tag Library`;
        }
        dispatch('studioToast/triggerToast', { msg: errorMessage, mode: 'error' }, { root: true });
        throw error;
      });
  },
  deleteTag({ state, commit, dispatch }, tagToDelete: Tag) {
    const tagName = tagToDelete.tag_name || '';
    const tagToastName = tagName.length > 20 ? `${tagName.slice(0, 20)}...` : tagName;

    return destroyTagLibrary({ id: tagToDelete.id })
      .then(() => {
        const tagsMap = { ...state.tags };
        delete tagsMap[tagToDelete.id];
        commit('setTags', tagsMap);
        commit('studioEventList/removeSelectedTagId', tagToDelete.id, { root: true });
        dispatch('studioToast/triggerToast', { msg: `Tag "${tagToastName}" deleted`, mode: 'success' }, { root: true });
      })
      .catch(() => {
        dispatch(
          'studioToast/triggerToast',
          { msg: `Error deleting tag "${tagToastName}"`, mode: 'error' },
          { root: true }
        );
      });
  }
};

export default actions;
